<template>
    <List :list="list" :emptyText="emptyText" :language="language" :foldLimit="foldLimit" />
</template>
<script>
import { library } from '@futuweb/fego-bridge';
import FEGORender from '@futuweb/fego-render';
import { isH5 } from './utils';
import { LANG } from '../editor/i18n';

const { dayjs } = library;

export default {
    name: 'reward-list',
    components: {
        List: () => import('./List.vue')
    },
    props: {
        language: {
            type: String,
            default: LANG.EN
        },
        emptyText: {
            type: String,
            default: 'No record'
        },
        orderBy: {
            type: String
        },
        actList: {
            type: Array,
            default: () => []
        },
        foldLimit: {
            // 超出折叠数量
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            list: [],
            isH5: isH5()
        };
    },
    mounted() {
        if (window._params.uid > 0) {
            this.getList();
        }
    },
    methods: {
        formatTime(time) {
            return dayjs.unix(time).format('YYYY.MM.DD HH:mm:ss');
        },
        async getList() {
            const { request } = FEGORender.common;
            const apiRewardList = request.bindCommonApi('reward-list');

            const bizIds = Array.from(new Set(this.actList.map((item) => item.businessId)));
            if (!bizIds.length) {
                console.error('未配置组件');
                return;
            }
            const res = await apiRewardList.post(
                'all',
                {
                    reward_group: bizIds.map((bizId) => ({
                        business_id: bizId
                    })),
                    lang: this.language,
                    order_by: this.orderBy
                },
                {
                    group: null // 不需要限制请求频次
                }
            );
            const list = [];
            const rewardMap = {};
            this.actList.forEach((actItem) => {
                actItem.rewardList &&
                    actItem.rewardList.forEach((rewardItem) => {
                        rewardMap[rewardItem.prizeSign] = rewardItem;
                    });
            });
            res.forEach((item) => {
                const prizeSign = `${item.awardId}-${item.prizeId}`;
                const rewardConfig = rewardMap[prizeSign];
                if (!rewardConfig) {
                    return;
                }

                list.push(
                    Object.assign({}, rewardConfig, {
                        createTime: item.createTime
                    })
                );
            });

            this.list = list;
        },
        refresh() {
            this.getList();
        }
    }
};
</script>
<style lang="less" scoped></style>
